module.exports = __webpack_public_path__ + "img/sp_foot_ico01_active.72ad2fd9.svg";